import { render, staticRenderFns } from "./BillingHandlingInIndex.vue?vue&type=template&id=55974b74&scoped=true&"
import script from "./BillingHandlingInIndex.vue?vue&type=script&lang=js&"
export * from "./BillingHandlingInIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingHandlingInIndex.vue?vue&type=style&index=0&id=55974b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55974b74",
  null
  
)

export default component.exports